import TextBookApi from '../../../api/src/textbook/api/TextBookApi'

const textBookApi = new TextBookApi();

const state = {
  textbook: {},
  unit: {},
  lesson: {}
}

const mutations = {
  changeLesson(state, {textbook, unit, lesson}) {
    state.textbook = textbook
    state.unit = unit
    state.lesson = lesson
  },
}

const actions = {
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}